import { useEffect, useState } from "react";
import { Alert, Box, Button, Card, CircularProgress, Icon, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import ContractDocument from "components/ContractAccess/Document";
import { getCurrentContract, getContractStatus } from "services/contracts";
import { canShowAdmin } from "services/categories";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

export default function ContractPage({ user }) {
  const [state, setState] = useState(null);
  const [error, setError] = useState("");
  const [revision, setRevision] = useState(0);
  const author = Boolean(user && !canShowAdmin(user));
  useEffect(() => {
    let active = true;
    setError("");
    setState(null);
    (author ? getContractStatus() : getCurrentContract())
      .then((result) => {
        if (active) setState(result);
      })
      .catch((failure) => {
        if (active) setError(failure.message);
      });
    return () => {
      active = false;
    };
  }, [user?.uid, author, revision]);
  const reload = () => setRevision((value) => value + 1);
  const accepted = () => {
    window.dispatchEvent(new Event("pso:contract-accepted"));
    reload();
  };
  const content = (
    <Box
      sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 3 }, minHeight: "100vh", bgcolor: "#f3f6f4" }}
    >
      <Box sx={{ maxWidth: 1100, mx: "auto" }}>
        {user && (
          <Button
            component={Link}
            to="/dashboard"
            startIcon={<Icon>arrow_back</Icon>}
            sx={{ mb: 2 }}
          >
            Voltar à plataforma
          </Button>
        )}
        <Card sx={{ p: { xs: 2, md: 4 }, borderRadius: 3, borderTop: "4px solid #16bc3f" }}>
          {error ? (
            <Stack spacing={2}>
              <Alert severity="error">{error}</Alert>
              <Button onClick={reload}>Tentar novamente</Button>
            </Stack>
          ) : state?.contract ? (
            <ContractDocument
              key={state.contract.versionId}
              contract={state.contract}
              required={author && !state.accepted}
              accepted={state.accepted}
              onAccepted={accepted}
              onReload={reload}
            />
          ) : (
            <CircularProgress aria-label="Carregando contrato" />
          )}
          {state?.accepted && (
            <Alert
              severity="success"
              sx={{ mt: 3 }}
              action={
                <Button component={Link} to="/dashboard">
                  Continuar
                </Button>
              }
            >
              Seu aceite desta versão está registrado.
            </Alert>
          )}
        </Card>
      </Box>
    </Box>
  );
  return user ? <DashboardLayout>{content}</DashboardLayout> : content;
}
